import { render, staticRenderFns } from "./no-use-open-block.vue?vue&type=template&id=83993494&scoped=true&lang=pug&"
import script from "./no-use-open-block.vue?vue&type=script&lang=js&"
export * from "./no-use-open-block.vue?vue&type=script&lang=js&"
import style0 from "./no-use-open-block.vue?vue&type=style&index=0&id=83993494&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83993494",
  null
  
)

export default component.exports